var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRebootIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.16875 5.45625L1.61875 5.84375C1.54062 6.13438 1.5 6.4375 1.5 6.75C1.5 8.68125 3.06875 10.25 5 10.25C6.93125 10.25 8.5 8.68125 8.5 6.75C8.5 4.81875 6.93125 3.25 5 3.25V5L1 2.5L5 0V1.75C7.7625 1.75 10 3.9875 10 6.75C10 9.5125 7.7625 11.75 5 11.75C2.2375 11.75 0 9.5125 0 6.75C0 6.30312 0.059375 5.86875 0.16875 5.45625Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebootIcon);
export default __webpack_public_path__ + "static/media/RebootIcon.2b2e78e0130890410c66468dc17742d3.svg";
export { ForwardRef as ReactComponent };